/* eslint-disable jsx-a11y/iframe-has-title */
import { LeftOutlined, RightOutlined } from '@ant-design/icons';
import { Button } from 'antd';
import axios from 'axios';
import { format } from 'date-fns';
import { vi } from 'date-fns/locale';
import { AnimatePresence, motion } from 'framer-motion';
import { useEffect, useRef, useState } from 'react';
import { AiOutlineRight } from 'react-icons/ai';
import { SlEarphones } from 'react-icons/sl';
import { useNavigate } from 'react-router-dom';
import SwiperCore, { EffectCoverflow } from "swiper";
import { MainState } from '../../MainProvider';
import { getArticlesByCategoryId, getArticlesByClusterId, getArticlesTiktok, getArticlesYoutube, getLatestArticles } from '../../api/articles/articlesApi';
import { getCategories } from '../../api/category/categoryApi';
import { getClusterBySize, getTopFiveMostNewsInCategory } from '../../api/clusters/clustersApi';
import { getTodayNews } from '../../api/todaynews/todaynews';
import { IEcosystem } from '../../common/tin-gpt/define-news';
import Ecosystem from '../../components/Ecosystem/Ecosystem';
import CategoryNewsLoader from '../../components/Loader/CategoryNewsLoader';
import HorizontalNewsLoader from '../../components/Loader/HorizontalNewsLoader';
import VerticalNewsLoader from '../../components/Loader/VerticalNewsLoader';
import WeatherLoader from '../../components/Loader/WeatherLoader';
import YoutubeNewsLoader from '../../components/Loader/YoutubeNewsLoader';
import CategoryNewsContainer from '../../components/News/CategoryNews/CategoryNewsContainer';
import CategoryNewsContainerResponsive from '../../components/News/CategoryNews/CategoryNewsContainerResponsive';
import CategoryNewsMain from '../../components/News/CategoryNews/CategoryNewsMain';
import HorizontalNews from '../../components/News/HorizontalNews/HorizontalNews';
import HorizontalNewsResponsive from '../../components/News/HorizontalNews/HorizontalNewsResponsive';
import MainNews from '../../components/News/MainNews/MainNews';
import OtherNews from '../../components/News/OtherNews/OtherNews';
import VerticalNews from '../../components/News/VerticalNews/VerticalNews';
import Video from '../../components/Video/Video';
import Weather from '../../components/Weather/Weather';
import ImageEcosystemHome1 from '../../images/homepage/ecosystem-home-image-1.svg';
import ImageEcosystemHome2 from '../../images/homepage/ecosystem-home-image-2.svg';
import ImageEcosystemHome3 from '../../images/homepage/ecosystem-home-image-3.svg';
import ImageEcosystemHome4 from '../../images/homepage/ecosystem-home-image-4.svg';
import ImageTodayNews from '../../images/homepage/image-today-news.svg';
import LogoTodayNew from '../../images/icon/icon-8am.svg';
import './styles.home.scss';
import VideoTiktok from '../../components/Video/VideoTiktok';
SwiperCore.use([EffectCoverflow]);


const EcosystemHomeList: IEcosystem[] = [
    {
        image: ImageEcosystemHome1,
        title: 'Hộp tin 8am ',
        description: 'Đăng ký nhận tin hàng tuần để luôn theo kịp thế giới',
    },
    {
        image: ImageEcosystemHome2,
        title: '8am việc làm',
        description: 'Trang tổng hợp việc làm từ nhiều nguồn nhất tại Việt Nam',
    },
    {
        image: ImageEcosystemHome3,
        title: '8am International',
        description: 'Trang tin tiếng anh với nhiều góc nhìn quốc tế',
    },
    {
        image: ImageEcosystemHome4,
        title: '8am podcast',
        description: 'Chỉ vài phút với audio tổng hợp tin hàng ngày',
    }
]

const days = ['Chủ Nhật', 'Thứ Hai', 'Thứ Ba', 'Thứ Tư', 'Thứ Năm', 'Thứ Sáu', 'Thứ Bảy'];


// Phần trang chủ của trang web
const Home = () => {
    // const [scrolledDown, setScrolledDown] = useState(false); // Kiểm tra xem người dùng đã cuộn xuống chưa

    const { clusters, setClusters, articles, setArticles, lastest, setLastest, categorys, setCategorys, lstNewsByCategory, setLstNewsByCategory, lstYoutubeNews, setLstYoutubeNews, lstTiktokNews, setLstTiktokNews, lstClusterByCategory, isResponsive, widthWeb, summaryCluster, setSummaryCluster, opinionCluster, setOpinionCluster, categoryMainNewsHome, setCategoryMainNewsHome, opinionNews, setOpinionNews, lstDifferentNews, setLstDifferentNews, currentWeather, setCurrentWeather, todayWeather, setTodayWeather } = MainState();

    const [loading, setLoading] = useState<boolean>(false)
    const [loadingCategory, setLoadingCategory] = useState<boolean>(false)
    const [loadingWeather, setLoadingWeather] = useState<boolean>(true)
    const [pageSizeLastestNews, setPageSizeLastestNews] = useState<number>(5)
    const [pageSizeCluster, setPageSizeCluster] = useState<number>(10)
    const [responsivePageSizeCluster, setResponsivePageSizeCluster] = useState<number>(6)
    const [offsetCluster, setOffsetCluster] = useState<number>(0)

    const [isClickViewMoreFeaturesNews, setIsClickViewMoreFeaturesNews] = useState<boolean>(false)

    // const [apiKeyIpinfo, setApiKeyIpinfo] = useState('e1d1dde95c3aa7'); // Api key của ipinfo
    const [apiKeyOpenWeather, setApiKeyOpenWeather] = useState('b69264579f9acb54ea5cf3230ea526b2'); // Api key của open weather
    const [apiKeyOpenCateData, setApiKeyOpenCateData] = useState('5649d5582cec40d1a3cf761aee0021d5'); // Api key của open weather
    const [loadingHeight, setLoadingHeight] = useState(0); // Chiều cao của phần loading

    // const [location, setLocation] = useState<any>(null);
    // const [weather, setWeather] = useState<any>(null);
    const [isOutOfData, setIsOutOfData] = useState<boolean>(false);
    // const [isOutOfDataVideo, setIsOutOfDataVideo] = useState<boolean>(false);
    const listRef = useRef<any>(null);
    const listVideoRef = useRef<any>(null);
    const listVideoTikTokRef = useRef<any>(null);
    const [isLeftButtonVisible, setIsLeftButtonVisible] = useState(false);
    const [isRightButtonVisible, setIsRightButtonVisible] = useState(true);
    const [isLeftButtonVisibleVideo, setIsLeftButtonVisibleVideo] = useState(false);
    const [isRightButtonVisibleVideo, setIsRightButtonVisibleVideo] = useState(true);
    const [isLeftButtonVisibleCategory, setIsLeftButtonVisibleCategory] = useState(false);
    const [isRightButtonVisibleCategory, setIsRightButtonVisibleCategory] = useState(true);

    // const [loadingProgress, setLoadingProgress] = useState(0);
    // const [onclickAudio, setOnclickAudio] = useState(false);
    // const [isAudioLoading, setIsAudioLoading] = useState(false);

    // const [showTextTodayNews, setShowTextTodayNews] = useState<boolean>(false);
    const navigate = useNavigate();

    useEffect(() => {

        (!currentWeather && !todayWeather) && handleLocationClick();
        // getAllCategory();
        clusters.length <= 0 && featchData();
        // featchData();
        (!isResponsive && lastest.length <= 0) && getLstLatestArticles();
        (!isResponsive && !summaryCluster) && getTodayNewsSummary();
        (opinionCluster.length <= 0) && getOpinionCluster();
        scrollFeatureNews();
        // getMainWeather();

        // getLineTextTodayNews();
    }, [])

    useEffect(() => {
        if (summaryCluster && !isResponsive) setTextInTodayNews();
    }, [summaryCluster, isResponsive, loading])

    useEffect(() => {
        if (clusters && clusters.length > 0 && !isClickViewMoreFeaturesNews && articles.length <= 0) {
            getLstArticleByCluster();
        }
    }, [clusters])

    useEffect(() => {
        if (articles && articles.length > 0 && !categoryMainNewsHome) {
            console.log(articles);

            // Lấy ra category theo list category id
            const category = categorys.filter((category: any) => category.categoryId === articles[0].cluster.categoryId);

            console.log(category);

            if (category && category.length > 0) {
                setCategoryMainNewsHome(category[0].name);
            }
        }
    }, [articles])

    useEffect(() => {
        isOutOfData ? setIsRightButtonVisible(false) : setIsRightButtonVisible(true);
    }, [isOutOfData])

    // Sự kiện khi người dùng cuộn trang
    useEffect(() => {
        document.body.addEventListener("scroll", handleScroll);
        return () => {
            document.body.removeEventListener("scroll", handleScroll);
        };
    }, [loadingHeight]);

    useEffect(() => {
        if (categorys && categorys.length > 0 && lstNewsByCategory.length <= 0 && lstYoutubeNews.length <= 0) {
            console.log(categorys);
            setTimeout(() => {
                getAllNewsByCategory()
                getVideoYoutube();
                getVideoTikTok();
            }, 1000);
        }
    }, [categorys])

    useEffect(() => {
        console.log(lstNewsByCategory);


        if (lstClusterByCategory && lstClusterByCategory.length > 0 && lstNewsByCategory.length <= 0) {
            // Kiểm tra người dùng có đang scroll đến class name  là category-news không thì thực hiện hàm
            console.log(lstClusterByCategory);
            // Thực hiện hàm sau 1s
            setTimeout(() => {
                getAllNewsFromCategoryCluster(lstClusterByCategory);
            }, 1000);
            // getAllNewsFromCategoryCluster(lstClusterByCategory);
        }

    }, [lstClusterByCategory])

    useEffect(() => {
        if (opinionCluster && opinionCluster.length > 0 && opinionNews.length <= 0) {
            getOpinionNews();
        }
    }, [opinionCluster])

    useEffect(() => {
        console.log(opinionNews);

    }, [opinionNews])

    const scrollFeatureNews = () => {
        const slider = document.querySelector('.featured-news-list') as any;
        let isDown = false;
        let startX: number;
        let scrollLeft: number;
        if (!slider) return;
        slider.addEventListener('mousedown', (e: any) => {
            isDown = true;
            slider.classList.add('active');
            startX = e.pageX - slider.offsetLeft;
            scrollLeft = slider.scrollLeft;
        });
        slider.addEventListener('mouseleave', () => {
            isDown = false;
            slider.classList.remove('active');
        });
        slider.addEventListener('mouseup', () => {
            isDown = false;
            slider.classList.remove('active');
        });
        slider.addEventListener('mousemove', (e: any) => {
            if (!isDown) return;
            e.preventDefault();
            const x = e.pageX - slider.offsetLeft;
            const walk = (x - startX) * 2; //scroll-fast
            slider.scrollLeft = scrollLeft - walk;
        });
    }

    function handleLocationClick() {
        setLoadingWeather(true);
        if (navigator.geolocation) {
            navigator.geolocation.getCurrentPosition(success, error);
        } else {

            console.log("Geolocation not supported");
        }
    }

    async function success(position: any) {
        setLoadingWeather(true);
        const latitude = position.coords.latitude;
        const longitude = position.coords.longitude;
        // setLocation({ latitude, longitude });
        console.log(`Latitude: ${latitude}, Longitude: ${longitude}`);

        // Now use OpenCage Geocoder to get city name
        await fetch(`https://api.opencagedata.com/geocode/v1/json?q=${latitude}+${longitude}&key=${apiKeyOpenCateData}`)
            .then(response => response.json())
            .then(async data => {
                console.log('====================================');
                console.log(data.results[0].components.city);
                console.log('====================================');
                const cityName = data.results[0].components.city;
                const apiUrl = `https://api.openweathermap.org/data/2.5/weather?q=${cityName}&appid=${apiKeyOpenWeather}&units=metric&lang=vi`;

                await axios.get(apiUrl).then((response) => {
                    setCurrentWeather(response.data);
                });

                const weekUrl = `https://api.openweathermap.org/data/2.5/forecast?q=${cityName}&appid=${apiKeyOpenWeather}&units=metric&lang=vi`
                await axios.get(weekUrl).then((response) => {
                    setTodayWeather(response.data.list);
                });
                setLoadingWeather(false);
            })
            .catch(error => console.log(error));

    }

    async function error() {
        console.log("Unable to retrieve your location");
        setLoadingWeather(true);

        const latitude = 21.028511;
        const longitude = 105.804817;
        // setLocation({ latitude, longitude });
        console.log(`Latitude: ${latitude}, Longitude: ${longitude}`);

        // Now use OpenCage Geocoder to get city name
        await fetch(`https://api.opencagedata.com/geocode/v1/json?q=${latitude}+${longitude}&key=${apiKeyOpenCateData}`)
            .then(response => response.json())
            .then(async data => {
                console.log('====================================');
                console.log(data.results[0].components.city);
                console.log('====================================');
                const cityName = data.results[0].components.city;
                const apiUrl = `https://api.openweathermap.org/data/2.5/weather?q=${cityName}&appid=${apiKeyOpenWeather}&units=metric&lang=vi`;

                await axios.get(apiUrl).then((response) => {
                    setCurrentWeather(response.data);
                });

                const weekUrl = `https://api.openweathermap.org/data/2.5/forecast?q=${cityName}&appid=${apiKeyOpenWeather}&units=metric&lang=vi`
                await axios.get(weekUrl).then((response) => {
                    setTodayWeather(response.data.list);
                });
                setLoadingWeather(false);
            })
            .catch(error => console.log(error));
    }

    const featchData = async () => {
        setLoading(true);
        const req = {
            size: isResponsive ? responsivePageSizeCluster : pageSizeCluster,
            offset: offsetCluster,
        }
        await getClusterBySize(req)
            .then((data) => {
                console.log(data?.data?.data?.items);
                if (data?.data?.data) {
                    setClusters(data?.data?.data?.items);
                }
            })
    }

    const getLstArticleByCluster = async () => {
        let tmp: any[] = []
        console.log(tmp);
        for (let index = 0; index < clusters.length; index++) {
            const element = clusters[index];
            const clusterId = element.id;
            let req = {};
            if (isResponsive) {
                req = {
                    size: 1,
                    offset: 0,
                    clusterId: clusterId
                }
            }
            else {
                if (index <= 2) {
                    req = {
                        size: 3,
                        offset: 0,
                        clusterId: clusterId
                    }
                }
                else {
                    req = {
                        size: 1,
                        offset: 0,
                        clusterId: clusterId
                    }
                }

            }
            console.log(req);

            await getArticlesByClusterId(req)
                .then((data) => {
                    // console.log(data?.data?.data[0].items);
                    if (data?.data?.data?.items && data?.data?.data?.items.length > 0) {
                        tmp.push({
                            cluster: element,
                            articles: data?.data?.data.items
                        })
                    }
                })
                .catch((err) => {

                    console.log(err);
                })
        }
        if (tmp && tmp.length > 0) {
            console.log(tmp);

            setArticles(tmp);
            setLoading(false);
        }

    }

    const getLstLatestArticles = async () => {
        const req = {
            size: 6,
            offset: 0,
        }
        await getLatestArticles(req)
            .then((data) => {
                if (data?.data?.data) {
                    console.log(data?.data?.data);
                    // console.log(data?.data?.data);
                    setLastest(data?.data?.data?.items);
                }
            })
    }

    const handleClickViewMoreLastestNews = () => {
        // add 3 more news in lastest news list
        // setPageSizeLastestNews(pageSizeLastestNews + 3)
        navigate('/lastest-news')
    }

    const scrollLeft = () => {
        listRef.current.scrollBy({ left: -400, behavior: 'smooth' });
    };

    const scrollLeftVideo = () => {
        listVideoRef.current.scrollBy({ left: -400, behavior: 'smooth' });
    }

    const scrollLeftTikTok = () => {
        listVideoTikTokRef.current.scrollBy({ left: -400, behavior: 'smooth' });
    }

    const scrollRight = () => {
        listRef.current.scrollBy({ left: 400, behavior: 'smooth' });
    };

    const scrollRightVideo = () => {
        listVideoRef.current.scrollBy({ left: 400, behavior: 'smooth' });
    }

    const scrollRightTikTok = () => {
        listVideoTikTokRef.current.scrollBy({ left: 400, behavior: 'smooth' });
    }

    const handleScrollLst = () => {
        setIsLeftButtonVisible(listRef.current.scrollLeft > 0);
        // setIsRightButtonVisible(listRef.current.scrollWidth - listRef.current.scrollLeft > listRef.current.clientWidth);
    };

    const handleScrollLstVideo = () => {
        setIsLeftButtonVisibleVideo(listVideoRef.current.scrollLeft > 0);
        // setIsRightButtonVisibleVideo(listVideoRef.current.scrollWidth - listVideoRef.current.scrollLeft > listVideoRef.current.clientWidth);
    }

    const handleScrollLstTikTok = () => {
        setIsLeftButtonVisibleVideo(listVideoTikTokRef.current.scrollLeft > 0);
        // setIsRightButtonVisibleVideo(listVideoTikTokRef.current.scrollWidth - listVideoTikTokRef.current.scrollLeft > listVideoTikTokRef.current.clientWidth);
    }

    // Hàm xử lý sự kiện khi người dùng cuộn trang
    const handleScroll = () => {
        // const { scrollTop, scrollHeight, clientHeight } = document.body;
        // Kiểm tra đã cuộn xuống chưa
        // scrollTop > 0 ? setScrolledDown(true) : setScrolledDown(false);

    };

    const getTodayNewsSummary = async () => {
        await getTodayNews()
            .then((data: any) => {
                console.log(data?.data?.data[0]);
                if ((data.data.data[0])) {
                    const keywords = data.data.data[0].keywords;
                    // Gộp các keyword lại thành 1 string
                    // Xóa 1. 2. 3. trong đoạn text
                    let combinedKeywords = keywords.map((keyword: any) => keyword.replace(/\d+\.\s/g, '')).join(',');
                    combinedKeywords = combinedKeywords.split(', ').map((keyword: any) => keyword.charAt(0).toUpperCase() + keyword.slice(1)).join(', ');

                    // Gộp các keyword lại thành 1 string
                    let summary = combinedKeywords;

                    setSummaryCluster(summary);
                }
            })
    }

    const getVideoYoutube = async () => {

        const req = {
            size: 5,
            offset: 0,
        }
        await getArticlesYoutube(req)
            .then((data: any) => {
                console.log(data?.data?.data?.items);
                if (data?.data?.data?.items) {
                    setLstYoutubeNews(data?.data?.data?.items);
                }
            })
            .catch((err) => {
                console.log(err);
            })

    }

    const getVideoTikTok = async () => {

        const req = {
            size: 5,
            offset: 0,
        }
        await getArticlesTiktok(req)
            .then((data: any) => {
                console.log(data?.data?.data?.items);
                if (data?.data?.data?.items) {
                    setLstTiktokNews(data?.data?.data?.items);
                }
            })
            .catch((err) => {
                console.log(err);
            })

    }

    const getAllNewsFromCategoryCluster = async (clusters: any) => {
        let tmp: any[] = [];
        console.log('====================================');
        console.log(clusters);
        console.log('====================================');
        for (let index = 0; index < clusters.length; index++) {
            const cluster = clusters[index];
            console.log(cluster);

            const req = {
                size: 4,
                offset: 0,
                clusterId: cluster.clusters[0].id
            }
            await getArticlesByClusterId(req)
                .then((data) => {
                    console.log(data?.data?.data?.items);
                    if (data?.data?.data?.items && data?.data?.data?.items.length > 0) {
                        tmp.push({
                            category: cluster.category,
                            articles: data?.data?.data?.items,
                            numberNews: cluster.clusters[0].totalNumberOfArticles
                        })
                    }
                })
                .catch((err) => {
                    console.log(err);
                })
        }
        if (tmp && tmp.length > 0) {
            console.log(tmp);

            setLstNewsByCategory(tmp);
        }
        setLoadingCategory(false);
    }

    const setTextInTodayNews = () => {
        const arraySummary = summaryCluster.split(', ');
        // Thêm 1 phần tử vào đầu mảng arraySummary
        arraySummary.unshift(`Bản tin ${days[new Date().getDay()]}:`);

        // Thêm text vào title-main-today-news, khi nào height của title-main-today-news lớn hơn 3 dòng thì thêm dấu ... vào cuối
        let textContentToday = document.querySelector('.text-content-today') as any;
        console.log(textContentToday);
        if (!textContentToday) return;
        let i = 0;
        while (i < arraySummary.length) {
            if (i === 0) {
                textContentToday.innerHTML += `${arraySummary[i]} `;
            }
            else {
                textContentToday.innerHTML += `${arraySummary[i]}, `;
            }
            i++;
            const height = textContentToday.getBoundingClientRect().height;
            if (height >= 24 * 3) {
                // Xóa dấu , ở cuối
                textContentToday.innerHTML = textContentToday.innerHTML.slice(0, -2);
                textContentToday.innerHTML += '...';
                break;
            }
        }
    }

    const getAllNewsByCategory = async () => {
        let tmp: any[] = [];
        for (let index = 0; index < categorys.length; index++) {
            const element = categorys[index];
            const req = {
                size: 4,
                offset: 0,
                categoryId: element.categoryId
            }
            await getArticlesByCategoryId(req)
                .then((data) => {
                    if (data?.data?.data?.items && data?.data?.data?.items.length > 0) {
                        tmp.push({
                            category: element,
                            articles: data?.data?.data?.items
                        })
                    }
                })
                .catch((err) => {
                })
        }

        if (tmp && tmp.length > 0) {
            console.log(tmp);

            setLstDifferentNews(tmp);
        }
    }

    const getOpinionCluster = async () => {
        await getTopFiveMostNewsInCategory()
            .then((data) => {
                console.log(data?.data?.data?.items);
                if (data?.data?.data) {
                    setOpinionCluster(data?.data?.data?.items);
                }
            })
            .catch((err) => {
                console.log(err);
            })
    }

    const getOpinionNews = async () => {
        let tmp: any[] = [];
        for (let index = 0; index < opinionCluster.length; index++) {
            const element = opinionCluster[index];
            const req = {
                size: 1,
                offset: 0,
                clusterId: element.id
            }
            await getArticlesByClusterId(req)
                .then((data) => {
                    console.log(data?.data?.data?.items);
                    if (data?.data?.data?.items && data?.data?.data?.items.length > 0) {
                        tmp.push({
                            cluster: element,
                            articles: data?.data?.data?.items
                        })
                    }
                })
                .catch((err) => {
                    console.log(err);
                })
        }
        if (tmp && tmp.length > 0) {
            console.log(tmp);
            setOpinionNews(tmp);
        }
    }

    return (
        <>
            {(widthWeb > 1100 && widthWeb < 4000) &&
                <motion.div
                    className='main-home'
                    initial={{ opacity: 0 }}
                    animate={{ opacity: 1 }}
                    exit={{ opacity: 0 }}
                >
                    <>
                        <>
                            <div className='main-news-home'>
                                <div className='main-news-home-left'>
                                    {articles.length <= 0 ?
                                        <>
                                            <HorizontalNewsLoader />
                                            <HorizontalNewsLoader />
                                        </>
                                        :
                                        <>
                                            {(articles && articles.length > 1) && articles[1].articles?.slice(0, 1).map((news: any, index: any) => (
                                                <>
                                                    <HorizontalNews
                                                        newsContent={news}
                                                        newsCategory={''}
                                                        avgStd={articles[1].cluster.avgStd}
                                                    />
                                                    <div className='line-break'></div>
                                                </>
                                            ))}
                                            {(articles && articles.length > 2) && articles[2].articles?.slice(0, 1).map((news: any, index: any) => (
                                                <>
                                                    <HorizontalNews
                                                        newsContent={news}
                                                        newsCategory={''}
                                                        avgStd={articles[2].cluster.avgStd}
                                                    />
                                                    <div className='line-break'></div>
                                                </>
                                            ))}
                                        </>
                                    }
                                </div>
                                <div className={"main-news-home-center" + (articles.length <= 0 ? ' loader' : '')}>
                                    {
                                        articles.length <= 0 ?
                                            <>
                                                <HorizontalNewsLoader />
                                                <VerticalNewsLoader />
                                                <VerticalNewsLoader />
                                            </>
                                            :
                                            <>
                                                {(articles && articles.length > 0) &&
                                                    <MainNews
                                                        mainNews={articles[0]}
                                                        newsCategory={categoryMainNewsHome}
                                                    />
                                                }
                                            </>
                                    }
                                </div>
                                <div className='main-news-home-right'>
                                    {loadingWeather ?
                                        <WeatherLoader />
                                        :
                                        <Weather
                                            currentWeather={currentWeather}
                                            toDayWeather={todayWeather}
                                        />
                                    }
                                    {
                                        lastest.length <= 0 ?
                                            <>
                                                <VerticalNewsLoader type='reverse' />
                                                <VerticalNewsLoader type='reverse' />
                                                <VerticalNewsLoader type='reverse' />
                                                <VerticalNewsLoader type='reverse' />
                                            </>
                                            :
                                            <div className='lastest-news'>
                                                <div className='lastest-news-title'
                                                    onClick={handleClickViewMoreLastestNews}
                                                >Mới nhất</div>
                                                {(lastest && lastest.length > 0) && lastest?.slice(0, pageSizeLastestNews).map((news: any, index: any) => (
                                                    <>
                                                        <VerticalNews
                                                            newsContent={news}
                                                            newsCategory={''}
                                                            type={'reverse'}
                                                            isSmall={true}
                                                        />
                                                        <div className={`line-break nch-${index}`}></div>
                                                    </>
                                                ))}
                                                <div className='view-more-lastest-news' onClick={handleClickViewMoreLastestNews}>
                                                    Xem thêm
                                                    <AiOutlineRight />
                                                </div>
                                            </div>
                                    }
                                </div>

                                <div className='main-news-home-today'>
                                    {
                                        !summaryCluster
                                            ?
                                            <VerticalNewsLoader />
                                            :
                                            <>
                                                <div className="image-today">
                                                    <img src={ImageTodayNews} alt="" />
                                                </div>
                                                <div className="content-today"
                                                    onClick={() => {
                                                        // setIsAudioLoading(true);
                                                        navigate('/today-news');
                                                        // listionToNew()
                                                    }}
                                                >
                                                    <div className="title-content-today">
                                                        8am hôm nay
                                                    </div>
                                                    {summaryCluster ?
                                                        <div className='text-content-today'>
                                                            {/* {summaryCluster} */}
                                                            {/* Kiểm tra nếu text hiện quá 3 dòng thì hiển thị*/}
                                                            {/* {showTextTodayNews && */}
                                                            {/* <span>, và hơn nữa</span> */}
                                                            {/* } */}
                                                        </div>
                                                        :
                                                        <div className='text-content-today'>
                                                            Hiện chưa có tin tức nào
                                                        </div>
                                                    }

                                                    <div className='listen-news' onClick={() => {
                                                        // setIsAudioLoading(true);
                                                        navigate('/today-news');
                                                        // listionToNew()
                                                    }}>
                                                        <SlEarphones />
                                                        Nghe tin
                                                    </div>
                                                </div>
                                            </>
                                    }
                                </div>
                                <div />
                            </div>
                            <div className={'featured-news-list' + (articles.length <= 0 ? ' loader' : '')}>
                                {articles.length <= 0 ?
                                    <>
                                        <HorizontalNewsLoader />
                                        <HorizontalNewsLoader />
                                        <HorizontalNewsLoader />
                                        <HorizontalNewsLoader />
                                    </>
                                    :
                                    <AnimatePresence>
                                        <div className='home-featured-new'>
                                            {isLeftButtonVisible &&
                                                <Button onClick={scrollLeft}>
                                                    <LeftOutlined />
                                                </Button>
                                            }
                                            <div className="featured-news-list" ref={listRef} onScroll={handleScrollLst}>
                                                {articles.slice(3).map((news: any, index: any) => (
                                                    <HorizontalNews
                                                        newsContent={news.articles[0]}
                                                        newsCategory={''}
                                                        avgStd={news.cluster.avgStd}
                                                    />
                                                ))}
                                                {/* {!isOutOfData &&
                                            <Spin indicator={antIcon} spinning={loadingFeatureNews}>
                                                <div className={'view-more-features-news' + (loadingFeatureNews ? ' loader' : '')} onClick={handleViewMoreFeaturesNews}>
                                                    Xem thêm
                                                    <BsFillArrowRightCircleFill />
                                                </div>
                                            </Spin>
                                        } */}
                                            </div>
                                            {isRightButtonVisible &&
                                                <Button onClick={scrollRight}>
                                                    <RightOutlined />
                                                </Button>
                                            }
                                        </div>
                                    </AnimatePresence>
                                }
                            </div>
                        </>
                        <div className='category-news'>
                            <div className="category-item-with-opinion">
                                <div className={"category-lst" + (lstNewsByCategory.length <= 0 ? ' loaded' : '')}>
                                    {lstNewsByCategory.length <= 0 ?
                                        <>
                                            <HorizontalNewsLoader />
                                            <HorizontalNewsLoader />
                                        </>
                                        :
                                        <>
                                            {lstNewsByCategory.slice(0, 2).map((category: any, index: any) => (
                                                <>
                                                    {category?.articles.length > 2 &&
                                                        <div className='category-item'>
                                                            <div className='category-item-title'
                                                                onClick={() => {
                                                                    localStorage.setItem('category', JSON.stringify(category.category));
                                                                    const name = category.category.name.replace(/ /g, '-').toLowerCase();

                                                                    navigate(`/category/${name}`);
                                                                }}
                                                            >
                                                                {category.category.name} <RightOutlined />
                                                            </div>
                                                            <CategoryNewsContainer
                                                                categoryNews={category.articles}
                                                            />
                                                            <div className='view-more'
                                                                onClick={() => {
                                                                    localStorage.setItem('category', JSON.stringify(category.category));
                                                                    const name = category.category.name.replace(/ /g, '-').toLowerCase();
                                                                    navigate(`/category/${name}`);
                                                                }}
                                                            >
                                                                Xem thêm <span> {category.numberNews - 3}</span>
                                                            </div>
                                                        </div>
                                                    }
                                                </>
                                            ))}
                                        </>
                                    }
                                </div>
                                <div className={"opinion-lst" + (lstNewsByCategory.length <= 0 ? ' loaded' : '')}>
                                    {
                                        opinionNews.length <= 0 ?
                                            <>
                                                <HorizontalNewsLoader />
                                                <HorizontalNewsLoader />
                                            </>
                                            :
                                            <>
                                                <div className="opinion-lst-title">
                                                    Top 5
                                                </div>
                                                <div className='opinion-content'>
                                                    {opinionNews.map((opinion: any, index: any) => (
                                                        <div className='opinion-item'
                                                            onClick={() => {
                                                                const url = new URL(opinion.articles[0].link);
                                                                const text = url.hostname + url.pathname;
                                                                const id = opinion.articles[0].id;
                                                                console.log(text);
                                                                // const tmp = props.newsContent.title.replace(/[/,:?-]/g, '');
                                                                // const title = tmp.replace(/ /g, '-').toLowerCase();

                                                                if (opinion.articles[0].type === 'AI' || text.includes('watch')) {
                                                                    navigate(`/detail-news/id=${id}`,);
                                                                }
                                                                else {
                                                                    navigate(`/detail-news/${text}`);
                                                                }

                                                                // Gán giá trị id vào localStorage
                                                                localStorage.setItem('id', opinion.articles[0].id);
                                                                localStorage.setItem('link', opinion.articles[0].link);
                                                            }}

                                                        >
                                                            <div className='number-order'>{index + 1}</div>
                                                            <div className='opinion-item-content'>
                                                                <div className='opinion-item-text'>{opinion.articles[0].title}</div>
                                                            </div>
                                                        </div>
                                                    ))}
                                                </div>
                                            </>
                                    }
                                </div>
                            </div>
                        </div>

                        {
                            (lstNewsByCategory.length <= 2) ?
                                <div className='main-category loader'>
                                    <div className='main-category-item'>
                                        <CategoryNewsLoader />
                                    </div>
                                    <div className='main-category-item'>
                                        <CategoryNewsLoader />
                                    </div>
                                </div>
                                :
                                <div className='main-category'>
                                    <div className='main-category-lst'>
                                        {(lstNewsByCategory && lstNewsByCategory.length) && lstNewsByCategory.slice(2, 4).map((category: any, index: any) => (
                                            <div className='main-category-item'>
                                                <div className='main-category-item-title'
                                                    onClick={() => {
                                                        localStorage.setItem('category', JSON.stringify(category.category));
                                                        const name = category.category.name.replace(/ /g, '-').toLowerCase();

                                                        navigate(`/category/${name}`);
                                                    }}
                                                >
                                                    {category.category.name} <RightOutlined />
                                                </div>
                                                {category.articles.length > 0 &&
                                                    <CategoryNewsMain
                                                        newsContent={category.articles}
                                                        categoryHorizontalNews={category.articles[0]}
                                                        numberNews={category.numberNews}
                                                    />
                                                }
                                            </div>
                                        ))}
                                    </div>
                                </div>
                        }

                        <div className='home-ecosystem'>
                            <div className='title-home-ecosystem'>
                                Hệ sinh thái 8am
                            </div>
                            <div className='home-ecosystem-lst'>
                                {(EcosystemHomeList && EcosystemHomeList.length) && EcosystemHomeList.map((ecosystem, index) => (
                                    <>
                                        <Ecosystem
                                            ecosystemItem={ecosystem}
                                        />
                                    </>

                                ))}
                            </div>
                        </div>

                        {
                            (lstNewsByCategory.length <= 4) ?
                                <div className='main-category loader'>
                                    <div className='main-category-item'>
                                        <CategoryNewsLoader />
                                    </div>
                                    <div className='main-category-item'>
                                        <CategoryNewsLoader />
                                    </div>
                                </div>
                                :
                                <div className='main-category'>
                                    <div className='main-category-lst'>
                                        {(lstNewsByCategory && lstNewsByCategory.length) && lstNewsByCategory.slice(4, 6).map((category: any, index: any) => (
                                            <div className='main-category-item'>
                                                <div className='main-category-item-title'
                                                    onClick={() => {
                                                        localStorage.setItem('category', JSON.stringify(category.category));
                                                        const name = category.category.name.replace(/ /g, '-').toLowerCase();

                                                        navigate(`/category/${name}`);
                                                    }}
                                                >
                                                    {category.category.name} <RightOutlined />
                                                </div>
                                                {category.articles.length > 0 &&
                                                    <CategoryNewsMain
                                                        newsContent={category.articles}
                                                        categoryHorizontalNews={category.articles[0]}
                                                        numberNews={category.numberNews}
                                                    />
                                                }
                                            </div>
                                        ))}
                                    </div>
                                </div>

                        }

                        {(lstYoutubeNews.length <= 0) ?
                            <div className='home-video loader'>
                                <YoutubeNewsLoader />
                                <YoutubeNewsLoader />
                                <YoutubeNewsLoader />
                                <YoutubeNewsLoader />
                            </div>
                            :
                            <div className='home-video'>
                                <div className='home-video-title'
                                    onClick={() => {
                                        setLastest([]);
                                        navigate(`/lastest-news/YOUTUBE_SHORT`);
                                    }}
                                >
                                    Video nổi bật <RightOutlined />
                                </div>
                                <AnimatePresence>
                                    <div className='home-video'>
                                        {(isLeftButtonVisibleVideo && lstYoutubeNews.length > 0) &&
                                            <Button onClick={scrollLeftVideo}>
                                                <LeftOutlined />
                                            </Button>
                                        }
                                        <div className="home-video-list" ref={listVideoRef} onScroll={handleScrollLstVideo}>

                                            {(lstYoutubeNews && lstYoutubeNews.length > 0) && lstYoutubeNews.map((video: any, index: any) => (
                                                <Video
                                                    videoContent={video}
                                                />

                                            ))}
                                             {(lstTiktokNews && lstTiktokNews.length > 0) && lstTiktokNews.map((video: any, index: any) => (
                                                <VideoTiktok
                                                    item={video}
                                                />

                                            ))}
                                            {/* {!isOutOfDataVideo &&
                                    <Spin indicator={antIcon} spinning={loadingVideo}>
                                        <div className={'view-more-features-news' + (loadingVideo ? ' loader' : '')} onClick={handleVideoMoreVideo}>
                                            Xem thêm
                                            <BsFillArrowRightCircleFill />
                                        </div>
                                    </Spin>
                                } */}
                                        </div>
                                        {(isRightButtonVisibleVideo && lstYoutubeNews.length > 0) &&
                                            <Button onClick={scrollRightVideo}>
                                                <RightOutlined />
                                            </Button>
                                        }
                                    </div>
                                </AnimatePresence>

                            </div>

                        }
                        {/* {(lstTiktokNews.length <= 0) ?
                            <div className='home-video loader'>
                                <YoutubeNewsLoader />
                                <YoutubeNewsLoader />
                                <YoutubeNewsLoader />
                                <YoutubeNewsLoader />
                            </div>
                            :
                            <div className='home-video'>
                                <div className='home-video-title'
                                    onClick={() => {
                                        setLastest([]);
                                        navigate(`/lastest-news/TIKTOK`);
                                    }}
                                >
                                    Video tik tok <RightOutlined />
                                </div>
                                <AnimatePresence>
                                    <div className='home-video'>
                                        {(isLeftButtonVisibleVideo && lstTiktokNews.length > 0) &&
                                            <Button onClick={scrollLeftTikTok}>
                                                <LeftOutlined />
                                            </Button>
                                        }
                                        <div className="home-video-list" ref={listVideoTikTokRef} onScroll={handleScrollLstTikTok}>

                                           
                                        </div>
                                        {(isRightButtonVisibleVideo && lstTiktokNews.length > 0) &&
                                            <Button onClick={scrollRightTikTok}>
                                                <RightOutlined />
                                            </Button>
                                        }
                                    </div>
                                </AnimatePresence>
                            </div>
                        } */}
                        {
                            lstDifferentNews.length <= 0 ?
                                <div className='home-other-news'>
                                    <div className='title-home-other-news'>
                                        Tin khác
                                    </div>
                                    <div className='lst-home-other-news'>
                                        <YoutubeNewsLoader />
                                        <YoutubeNewsLoader />
                                        <YoutubeNewsLoader />
                                        <YoutubeNewsLoader />
                                        <YoutubeNewsLoader />
                                        <YoutubeNewsLoader />
                                    </div>
                                </div>
                                :
                                <div className='home-other-news'>
                                    <div className='title-home-other-news'>
                                        Tin khác
                                    </div>
                                    <div className='lst-home-other-news'>
                                        {(lstDifferentNews && lstDifferentNews.length) && lstDifferentNews.map((otherNews: any, index: any) => (
                                            <OtherNews
                                                otherNewsLst={otherNews}
                                            />
                                        ))}
                                    </div>
                                </div>

                        }

                        {/* <div className='home-other-news'>
                            <div className='title-home-other-news'>
                                Nghệ thuật
                            </div>
                            <div className='lst-home-other-news'>
                                {(HomeArtNewsLst && HomeArtNewsLst.length) && HomeArtNewsLst.map((otherNews, index) => (
                                    <OtherNews
                                        otherNewsLst={otherNews}
                                    />
                                ))}
                            </div>
                        </div>

                        <div className='home-other-news'>
                            <div className='title-home-other-news'>
                                Đời sống
                            </div>
                            <div className='lst-home-other-news'>
                                {(HomeLiftNewsList && HomeLiftNewsList.length) && HomeLiftNewsList.map((otherNews, index) => (
                                    <OtherNews
                                        otherNewsLst={otherNews}
                                    />
                                ))}
                            </div>
                        </div> */}
                    </>
                </motion.div>
            }
            {(widthWeb > 450 && widthWeb <= 1100) &&
                <motion.div
                    className='main-home'
                    initial={{ opacity: 0 }}
                    animate={{ opacity: 1 }}
                    exit={{ opacity: 0 }}
                >
                    <>
                        <>
                            <div className='main-news-home'>
                                {
                                    (!currentWeather || !todayWeather) ?
                                        <HorizontalNewsLoader />
                                        :
                                        <Weather
                                            currentWeather={currentWeather}
                                            toDayWeather={todayWeather}
                                        />
                                }
                                <div className='main-news-home-center'>
                                    {
                                        articles.length <= 0 ?
                                            <>
                                                <HorizontalNewsLoader />
                                                <HorizontalNewsLoader />
                                            </>
                                            :
                                            <div className='category-lst' >
                                                {(articles && articles.length > 0) && articles.slice(0, 3).map((category: any, index: any) => (
                                                    <>
                                                        {category?.articles.length > 2 &&
                                                            <div className='category-item'>
                                                                {index === 0 &&
                                                                    <div className='category-item-title'>
                                                                        {categoryMainNewsHome}
                                                                    </div>
                                                                }
                                                                <CategoryNewsContainer
                                                                    categoryNews={category.articles}
                                                                />

                                                                <div className='line-break'></div>
                                                            </div>
                                                        }
                                                    </>
                                                ))}
                                            </div>
                                    }
                                </div>
                            </div>
                            <div className='home-featured-new'>
                                {
                                    articles.length <= 0 ?
                                        <div style={{
                                            display: 'flex',
                                            gap: 10,
                                        }}>
                                            <HorizontalNewsLoader />
                                            <HorizontalNewsLoader />
                                        </div>
                                        :
                                        <>
                                            {isLeftButtonVisible &&
                                                <Button onClick={scrollLeft}>
                                                    <LeftOutlined />
                                                </Button>
                                            }
                                            <div className="featured-news-list" ref={listRef} onScroll={handleScrollLst}>
                                                {(articles && articles.length > 0) && articles.slice(3).map((news: any, index: any) => (
                                                    <HorizontalNews
                                                        newsContent={news.articles[0]}
                                                        newsCategory={''}
                                                        avgStd={news.cluster.avgStd}
                                                    />
                                                ))}
                                                {/* {!isOutOfData &&
                                            <Spin indicator={antIcon} spinning={loadingFeatureNews}>
                                                <div className={'view-more-features-news' + (loadingFeatureNews ? ' loader' : '')} onClick={handleViewMoreFeaturesNews}>
                                                    Xem thêm
                                                    <BsFillArrowRightCircleFill />
                                                </div>
                                            </Spin>
                                        } */}
                                            </div>
                                            {isRightButtonVisible &&
                                                <Button onClick={scrollRight}>
                                                    <RightOutlined />
                                                </Button>
                                            }
                                        </>
                                }
                            </div>
                            <div className='lastest-news'>
                                {
                                    lastest.length > 0 ?
                                        <>
                                            <div className='lastest-news-title' onClick={handleClickViewMoreLastestNews} >Mới nhất</div>
                                            <div className='lastest-news-lst'>
                                                <div className='lastest-news-content'>
                                                    {(lastest && lastest.length > 0) && lastest?.slice(0, 3).map((news: any, index: any) => (
                                                        <VerticalNews
                                                            newsContent={news}
                                                            newsCategory={''}
                                                            type={'reverse'}
                                                            isSmall={true}
                                                        />
                                                    ))}
                                                </div>

                                                <div className='line-break'></div>

                                                <div className='lastest-news-content'>
                                                    {(lastest && lastest.length > 0) && lastest?.slice(3, 6).map((news: any, index: any) => (
                                                        <VerticalNews
                                                            newsContent={news}
                                                            newsCategory={''}
                                                            type={'reverse'}
                                                            isSmall={true}
                                                        />

                                                    ))}
                                                </div>
                                            </div>
                                            <div className='view-more-lastest-news' onClick={handleClickViewMoreLastestNews}>
                                                Xem thêm
                                                <AiOutlineRight />
                                            </div>
                                        </>
                                        :
                                        <div style={{
                                            display: 'flex',
                                            gap: 10,
                                        }}>
                                            <div>
                                                <VerticalNewsLoader type='reverse' />
                                                <VerticalNewsLoader type='reverse' />
                                                <VerticalNewsLoader type='reverse' />
                                                <VerticalNewsLoader type='reverse' />
                                            </div>
                                            <div>
                                                <VerticalNewsLoader type='reverse' />
                                                <VerticalNewsLoader type='reverse' />
                                                <VerticalNewsLoader type='reverse' />
                                                <VerticalNewsLoader type='reverse' />
                                            </div>
                                        </div>

                                }
                            </div>
                        </>
                        {lstNewsByCategory.length <= 0 ?
                            <div className='category-news'>
                                <HorizontalNewsLoader />
                                <HorizontalNewsLoader />
                            </div>
                            :
                            <div className='category-news'>
                                <div className='category-lst' >
                                    {(lstNewsByCategory && lstNewsByCategory.length > 0) && lstNewsByCategory.slice(0, 2).map((category: any, index: any) => (
                                        <>
                                            {category?.articles.length > 2 &&
                                                <div className='category-item' >
                                                    <div className='category-item-title'
                                                        onClick={() => {
                                                            localStorage.setItem('category', JSON.stringify(category.category));
                                                            const name = category.category.name.replace(/ /g, '-').toLowerCase();

                                                            navigate(`/category/${name}`);
                                                        }}
                                                    >
                                                        {category.category.name} <RightOutlined />
                                                    </div>
                                                    <CategoryNewsContainer
                                                        categoryNews={category.articles}
                                                    />
                                                </div>
                                            }
                                        </>
                                    ))}
                                </div>
                            </div>
                        }
                        {
                            opinionNews.length > 0 ?
                                <div className='opinion-lst'>
                                    <div className="opinion-lst-title">
                                        Top 5
                                    </div>
                                    <div className='opinion-content'>

                                        <div className='opinion-content-lst'>
                                            {(opinionNews && opinionNews.length > 0) && opinionNews.slice(0, 3).map((opinion: any, index: any) => (
                                                <div className='opinion-item'
                                                    onClick={() => {
                                                        const url = new URL(opinion.articles[0].link);
                                                        const text = url.hostname + url.pathname;
                                                        const id = opinion.articles[0].id;
                                                        console.log(text);
                                                        // const tmp = props.newsContent.title.replace(/[/,:?-]/g, '');
                                                        // const title = tmp.replace(/ /g, '-').toLowerCase();
                                                        if (opinion.articles[0].type === 'AI' || text.includes('watch')) {
                                                            navigate(`/detail-news/id=${id}`,);
                                                        }
                                                        else {
                                                            navigate(`/detail-news/${text}`);
                                                        }

                                                        // Gán giá trị id vào localStorage
                                                        localStorage.setItem('id', opinion.articles[0].id);
                                                        localStorage.setItem('link', opinion.articles[0].link);
                                                    }}

                                                >
                                                    <div className='number-order'>{index + 1}</div>
                                                    <div className='opinion-item-content'>
                                                        <div className='opinion-item-text'>{opinion.articles[0].title}</div>
                                                    </div>
                                                </div>
                                            ))}
                                        </div>

                                        <div className='line-break'></div>

                                        <div className='opinion-content-lst'>
                                            {(opinionNews && opinionNews.length > 0) && opinionNews.slice(3, 5).map((opinion: any, index: any) => (
                                                <div className='opinion-item'
                                                    onClick={() => {
                                                        const url = new URL(opinion.articles[0].link);
                                                        const text = url.hostname + url.pathname;
                                                        const id = opinion.articles[0].id;
                                                        console.log(text);
                                                        // const tmp = props.newsContent.title.replace(/[/,:?-]/g, '');
                                                        // const title = tmp.replace(/ /g, '-').toLowerCase();
                                                        if (opinion.articles[0].type === 'AI' || text.includes('watch')) {
                                                            navigate(`/detail-news/id=${id}`,);
                                                        }
                                                        else {
                                                            navigate(`/detail-news/${text}`);
                                                        }

                                                        // Gán giá trị id vào localStorage
                                                        localStorage.setItem('id', opinion.articles[0].id);
                                                        localStorage.setItem('link', opinion.articles[0].link);
                                                    }}

                                                >
                                                    <div className='number-order'>{index + 4}</div>
                                                    <div className='opinion-item-content'>
                                                        <div className='opinion-item-text'>{opinion.articles[0].title}</div>
                                                    </div>
                                                </div>
                                            ))}
                                        </div>
                                    </div>
                                </div>
                                :
                                <div style={{
                                    display: 'flex',
                                    gap: 10,
                                }}>
                                    <div>
                                        <VerticalNewsLoader type='reverse' />
                                        <VerticalNewsLoader type='reverse' />
                                        <VerticalNewsLoader type='reverse' />
                                    </div>
                                    <div>
                                        <VerticalNewsLoader type='reverse' />
                                        <VerticalNewsLoader type='reverse' />
                                        <VerticalNewsLoader type='reverse' />
                                    </div>
                                </div>

                        }

                        {
                            lstNewsByCategory.length <= 2 ?
                                <div className='main-category loader'>
                                    <HorizontalNewsLoader />
                                    <HorizontalNewsLoader />
                                </div>
                                :
                                <div className='main-category'>
                                    <div className='category-lst' >
                                        {(lstNewsByCategory && lstNewsByCategory.length > 0) && lstNewsByCategory.slice(2, 4).map((category: any, index: any) => (
                                            <>
                                                {category?.articles.length > 2 &&
                                                    <div className='category-item' >
                                                        <div className='category-item-title'
                                                            onClick={() => {
                                                                localStorage.setItem('category', JSON.stringify(category.category));
                                                                const name = category.category.name.replace(/ /g, '-').toLowerCase();

                                                                navigate(`/category/${name}`);
                                                            }}
                                                        >
                                                            {category.category.name} <RightOutlined />
                                                        </div>
                                                        <CategoryNewsContainer
                                                            categoryNews={category.articles}
                                                        />
                                                    </div>
                                                }
                                            </>
                                        ))}
                                    </div>
                                </div>

                        }
                        <div className='home-ecosystem'>
                            <div className='title-home-ecosystem'>
                                Hệ sinh thái 8am
                            </div>
                            <div className='home-ecosystem-lst'>
                                {(EcosystemHomeList && EcosystemHomeList.length) && EcosystemHomeList.map((ecosystem, index) => (
                                    <>
                                        <Ecosystem
                                            ecosystemItem={ecosystem}
                                        />
                                    </>
                                ))}
                            </div>
                        </div>

                        {
                            lstNewsByCategory.length <= 4 ?
                                <div className='main-category loader'>
                                    <HorizontalNewsLoader />
                                    <HorizontalNewsLoader />
                                </div>
                                :
                                <div className='main-category'>
                                    <div className='category-lst' >
                                        {(lstNewsByCategory && lstNewsByCategory.length > 0) && lstNewsByCategory.slice(4, 6).map((category: any, index: any) => (
                                            <>
                                                {category?.articles.length > 2 &&
                                                    <div className='category-item' >
                                                        <div className='category-item-title'
                                                            onClick={() => {
                                                                localStorage.setItem('category', JSON.stringify(category.category));
                                                                const name = category.category.name.replace(/ /g, '-').toLowerCase();

                                                                navigate(`/category/${name}`);
                                                            }}
                                                        >
                                                            {category.category.name} <RightOutlined />
                                                        </div>
                                                        <CategoryNewsContainer
                                                            categoryNews={category.articles}
                                                        />
                                                    </div>
                                                }
                                            </>
                                        ))}
                                    </div>
                                </div>
                        }

                        {
                            lstYoutubeNews.length <= 0 ?
                                <>
                                </>
                                :
                                <>
                                    <div className='home-video'>
                                        <div className='home-video-title'
                                            onClick={() => {
                                                setLastest([]);
                                                navigate(`/lastest-news/YOUTUBE_SHORT`);
                                            }}
                                        >
                                            Video nổi bật <RightOutlined />
                                        </div>
                                        <AnimatePresence>
                                            <div className='home-video-lst'>
                                                {(isLeftButtonVisibleVideo && lstYoutubeNews.length > 0) &&
                                                    <Button onClick={scrollLeftVideo}>
                                                        <LeftOutlined />
                                                    </Button>
                                                }
                                                <div className="home-video-list" ref={listVideoRef} onScroll={handleScrollLstVideo}>

                                                    {(lstYoutubeNews && lstYoutubeNews.length > 0) && lstYoutubeNews.map((video: any, index: any) => (
                                                        <motion.div
                                                            key={index}
                                                            initial={{ opacity: 0, x: 100 }}
                                                            animate={{ opacity: 1, x: 0 }}
                                                            exit={{ opacity: 0, x: 100 }}
                                                            transition={{ duration: 0.3 }}
                                                        >
                                                            <Video
                                                                videoContent={video}
                                                            />
                                                        </motion.div>
                                                    ))}

                                                    {(lstTiktokNews && lstTiktokNews.length > 0) && lstTiktokNews.map((video: any, index: any) => (
                                                        <motion.div
                                                            key={index}
                                                            initial={{ opacity: 0, x: 100 }}
                                                            animate={{ opacity: 1, x: 0 }}
                                                            exit={{ opacity: 0, x: 100 }}
                                                            transition={{ duration: 0.3 }}
                                                        >
                                                            <VideoTiktok
                                                                item={video}
                                                            />
                                                        </motion.div>
                                                    ))}
                                                    {/* {!isOutOfDataVideo &&
                                        <Spin indicator={antIcon} spinning={loadingVideo}>
                                            <div className={'view-more-features-news' + (loadingVideo ? ' loader' : '')} onClick={handleVideoMoreVideo}>
                                                Xem thêm
                                                <BsFillArrowRightCircleFill />
                                            </div>
                                        </Spin>
                                    } */}
                                                </div>
                                                {(isRightButtonVisibleVideo && lstYoutubeNews.length > 0) &&
                                                    <Button onClick={scrollRightVideo}>
                                                        <RightOutlined />
                                                    </Button>
                                                }
                                            </div>
                                        </AnimatePresence>

                                    </div>
                                </>
                        }


                        <div className='home-other-news'>
                            <div className='title-home-other-news'>
                                Tin khác
                            </div>
                            <div className='lst-home-other-news'>
                                {(lstDifferentNews && lstDifferentNews.length) && lstDifferentNews.map((otherNews: any, index: any) => (
                                    <OtherNews
                                        otherNewsLst={otherNews}
                                    />
                                ))}
                            </div>
                        </div>

                        {/* <div className='home-other-news'>
                            <div className='title-home-other-news'>
                                Nghệ thuật
                            </div>
                            <div className='lst-home-other-news'>
                                {(HomeArtNewsLst && HomeArtNewsLst.length) && HomeArtNewsLst.map((otherNews, index) => (
                                    <OtherNews
                                        otherNewsLst={otherNews}
                                    />
                                ))}
                            </div>
                        </div>

                        <div className='home-other-news'>
                            <div className='title-home-other-news'>
                                Đời sống
                            </div>
                            <div className='lst-home-other-news'>
                                {(HomeLiftNewsList && HomeLiftNewsList.length) && HomeLiftNewsList.map((otherNews, index) => (
                                    <OtherNews
                                        otherNewsLst={otherNews}
                                    />
                                ))}
                            </div>
                        </div> */}
                    </>
                </motion.div>
            }
            {(widthWeb > 0 && widthWeb <= 450) &&
                <motion.div
                    className='main-home-responsive'
                    initial={{ opacity: 0 }}
                    animate={{ opacity: 1 }}
                    exit={{ opacity: 0 }}
                >
                    <>
                        {loading ?
                            <>
                                <div className='main-news-home'>
                                    <div className='main-news-home-left'>
                                        <HorizontalNewsLoader />
                                        <HorizontalNewsLoader />
                                    </div>
                                    <div className='main-news-home-center loader'>
                                        <HorizontalNewsLoader />
                                        <VerticalNewsLoader />
                                        <VerticalNewsLoader />
                                    </div>
                                    <div className='main-news-home-right'>
                                        {loadingWeather &&
                                            <WeatherLoader />
                                        }
                                        <VerticalNewsLoader type='reverse' />
                                        <VerticalNewsLoader type='reverse' />
                                        <VerticalNewsLoader type='reverse' />
                                        <VerticalNewsLoader type='reverse' />

                                    </div>
                                    <div className='main-news-home-today'>
                                        <VerticalNewsLoader />
                                    </div>
                                    <div />
                                </div>
                                <div className="featured-news-list loader">
                                    <HorizontalNewsLoader />
                                    <HorizontalNewsLoader />
                                    <HorizontalNewsLoader />
                                    <HorizontalNewsLoader />
                                </div>
                            </>
                            :
                            <>
                                <div className='main-news-home'>
                                    <div className='title-main-news-home'>
                                        <span>Mới và Hot</span>
                                        <span>{format(new Date(), 'EEEE, dd.MM', { locale: vi })}</span>
                                    </div>
                                    <div className='main-news-home-content'>
                                        {articles && articles.length > 0 &&
                                            articles.slice(0, 3).map((article: any, index: any) => (
                                                <>
                                                    {(article && article.articles && article.articles.length > 0) &&
                                                        <HorizontalNewsResponsive
                                                            newsContent={article.articles[0]}
                                                            newsCategory={''}
                                                            avgStd={article.cluster.avgStd}
                                                            isSlider={true}
                                                            numberNews={article.cluster.totalNumberOfArticles}
                                                        />
                                                    }
                                                </>
                                            ))

                                        }
                                    </div>
                                    <div className='main-news-home-today'
                                        onClick={() => {
                                            // setIsAudioLoading(true);
                                            navigate('/today-news');
                                            // listionToNew()
                                        }}
                                    >
                                        <div className="image-today" >
                                            <div className='image-today-content'>
                                                <img src={LogoTodayNew} alt="" />
                                                <div className='title-today-news'>
                                                    8AM HÔM NAY
                                                </div>
                                            </div>
                                        </div>
                                        <div className="content-today">
                                            <div className='text-content-today'>
                                                {"Bản tin tổng hợp " + days[new Date().getDay()]}
                                            </div>
                                            <div className='listen-news' onClick={() => {
                                                // setIsAudioLoading(true);
                                                navigate('/today-news');
                                                // listionToNew()
                                            }}>
                                                Nghe tin
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className='home-featured-new'>
                                    {(articles && articles.length) && articles.slice(3, 6).map((news: any, index: any) => (
                                        <HorizontalNewsResponsive
                                            newsContent={news.articles[0]}
                                            newsCategory={''}
                                            avgStd={news.cluster.avgStd}
                                            isSlider={true}
                                            numberNews={news.cluster.totalNumberOfArticles}
                                        />
                                    ))}

                                </div>
                            </>
                        }
                        {(!lstNewsByCategory || lstNewsByCategory.length === 0) ?
                            <div className='category-news'>
                                <HorizontalNewsLoader />
                                <HorizontalNewsLoader />
                            </div>
                            :
                            <div className='category-news'>
                                <div className='category-lst' >
                                    {(lstNewsByCategory && lstNewsByCategory.length > 0) && lstNewsByCategory.slice(0, 2).map((category: any, index: any) => (
                                        <>
                                            {category?.articles.length > 2 &&
                                                <div className='category-item' >
                                                    <div className='category-item-title'
                                                        onClick={() => {
                                                            localStorage.setItem('category', JSON.stringify(category.category));
                                                            const name = category.category.name.replace(/ /g, '-').toLowerCase();
                                                            navigate(`/category/${name}`);
                                                        }}
                                                    >
                                                        {category.category.name} <RightOutlined />
                                                    </div>
                                                    <CategoryNewsContainerResponsive
                                                        categoryNews={category.articles}
                                                        numberNews={category.numberNews}
                                                    />
                                                </div>
                                            }
                                        </>
                                    ))}
                                </div>
                                <div className='opinion-lst'>
                                    <div className="opinion-lst-title">
                                        Top 5
                                    </div>
                                    <div className='opinion-content'>
                                        {(opinionNews && opinionNews.length > 0) && opinionNews.map((opinion: any, index: any) => (
                                            <div className='opinion-item'
                                                onClick={() => {
                                                    const url = new URL(opinion.articles[0].link);
                                                    const text = url.hostname + url.pathname;
                                                    const id = opinion.articles[0].id;
                                                    console.log(text);

                                                    if (opinion.articles[0].type === 'AI' || text.includes('watch')) {
                                                        navigate(`/detail-news/id=${id}`,);
                                                    }
                                                    else {
                                                        navigate(`/detail-news/${text}`);
                                                    }

                                                    // const tmp = props.newsContent.title.replace(/[/,:?-]/g, '');
                                                    // const title = tmp.replace(/ /g, '-').toLowerCase();

                                                    // Gán giá trị id vào localStorage
                                                    localStorage.setItem('id', opinion.articles[0].id);
                                                    localStorage.setItem('link', opinion.articles[0].link);
                                                }}

                                            >
                                                <div className='number-order'>{index + 1}</div>
                                                <div className='opinion-item-content'>
                                                    <div className='opinion-item-text'>{opinion.articles[0].title}</div>
                                                </div>
                                            </div>
                                        ))}

                                        {(opinionNews.length <= 0) &&
                                            <div className='opinion-items-loader'>
                                                <HorizontalNewsLoader />
                                                <HorizontalNewsLoader />
                                            </div>
                                        }
                                    </div>
                                </div>
                            </div>
                        }

                        {(!lstNewsByCategory || lstNewsByCategory.length === 0) ?
                            <div className='category-news'>
                                <HorizontalNewsLoader />
                                <HorizontalNewsLoader />
                            </div>
                            :
                            <div className='main-category'>
                                <div className='category-lst' >
                                    {(lstNewsByCategory && lstNewsByCategory.length > 0) && lstNewsByCategory.slice(2, 4).map((category: any, index: any) => (
                                        <>
                                            {category?.articles.length > 2 &&
                                                <div className='category-item' >
                                                    <div className='category-item-title'
                                                        onClick={() => {
                                                            localStorage.setItem('category', JSON.stringify(category.category));
                                                            const name = category.category.name.replace(/ /g, '-').toLowerCase();
                                                            navigate(`/category/${name}`);
                                                        }}
                                                    >
                                                        {category.category.name} <RightOutlined />
                                                    </div>
                                                    <CategoryNewsContainerResponsive
                                                        categoryNews={category.articles}
                                                        numberNews={category.numberNews}
                                                    />
                                                </div>
                                            }
                                        </>
                                    ))}
                                </div>
                            </div>
                        }
                        <div className='home-ecosystem'>
                            <div className='title-home-ecosystem'>
                                Hệ sinh thái 8am
                            </div>
                            <div className='home-ecosystem-lst'>
                                {(EcosystemHomeList && EcosystemHomeList.length) && EcosystemHomeList.map((ecosystem, index) => (
                                    <>
                                        <Ecosystem
                                            ecosystemItem={ecosystem}
                                        />
                                    </>

                                ))}
                            </div>
                        </div>

                        {(!lstNewsByCategory || lstNewsByCategory.length === 0) ?
                            <div className='category-news'>
                                <HorizontalNewsLoader />
                                <HorizontalNewsLoader />
                            </div>
                            :
                            <div className='main-category'>
                                <div className='category-lst' >
                                    {(lstNewsByCategory && lstNewsByCategory.length > 0) && lstNewsByCategory.slice(4, 6).map((category: any, index: any) => (
                                        <>
                                            {category?.articles.length > 2 &&
                                                <div className='category-item' >
                                                    <div className='category-item-title'
                                                        onClick={() => {
                                                            localStorage.setItem('category', JSON.stringify(category.category));
                                                            const name = category.category.name.replace(/ /g, '-').toLowerCase();
                                                            navigate(`/category/${name}`);
                                                        }}
                                                    >
                                                        {category.category.name} <RightOutlined />
                                                    </div>
                                                    <CategoryNewsContainerResponsive
                                                        categoryNews={category.articles}
                                                        numberNews={category.numberNews}
                                                    />
                                                </div>
                                            }
                                        </>
                                    ))}
                                </div>
                            </div>
                        }
                        <div className='home-video'>
                            <div className='home-video-title'
                                onClick={() => {
                                    setLastest([]);
                                    navigate(`/lastest-news/YOUTUBE_SHORT`);
                                }}
                            >
                                Video nổi bật <RightOutlined />
                            </div>
                            <div className="home-video-list" ref={listVideoRef} onScroll={handleScrollLstVideo}>

                                {(lstYoutubeNews && lstYoutubeNews.length > 0) && lstYoutubeNews.map((video: any, index: any) => (
                                    <Video
                                        videoContent={video}
                                    />
                                ))}

                                {(lstTiktokNews && lstTiktokNews.length > 0) && lstTiktokNews.map((video: any, index: any) => (
                                    <VideoTiktok
                                        item={video}
                                    />
                                ))}


                                {/* {!isOutOfDataVideo &&
                                        <Spin indicator={antIcon} spinning={loadingVideo}>
                                            <div className={'view-more-features-news' + (loadingVideo ? ' loader' : '')} onClick={handleVideoMoreVideo}>
                                                Xem thêm
                                                <BsFillArrowRightCircleFill />
                                            </div>
                                        </Spin>
                                    } */}
                            </div>

                        </div>

                        {/* <div className='main-category'>
                            <div className='category-lst' >
                                {(lstNewsByCategory && lstNewsByCategory.length > 0) && lstNewsByCategory.slice(0, 2).map((category: any, index: any) => (
                                    <>
                                        {category?.articles.length > 2 &&
                                            <div className='category-item' >
                                                <div className='category-item-title'
                                                    onClick={() => {
                                                        localStorage.setItem('category', JSON.stringify(category.category));
                                                        const name = category.category.name.replace(/ /g, '-').toLowerCase();
                                                        navigate(`/category/${name}`);
                                                    }}
                                                >
                                                    {category.category.name} <RightOutlined />
                                                </div>
                                                <CategoryNewsContainerResponsive
                                                    categoryNews={category.articles}
                                                />
                                            </div>
                                        }
                                    </>
                                ))}
                            </div>
                        </div> */}
                    </>
                </motion.div>
            }
        </>
    )
}

export default Home